<template>
    <a :href="route"
        class="group flex-1 flex items-center justify-center sm:justify-end bg-white bg-gray-warm-100 hover:bg-blue-100 focus:outline-none focus:shadow-none select-none border-t border-gray-400 leading-none py-4 px-5"
    >
        <div v-if="closing_date"
            class="text-sm md:text-base text-gray-600 group-hover:text-gray-700"
        >
            {{ $t('Closing Date') }}:
            <span class="font-semibold text-gray-700 group-hover:text-gray-800">{{ closing_date }}</span>
            <span class="hidden sm:inline mx-2">&bull;</span>
        </div>

        <div class="hidden sm:block text-sm md:text-base font-semibold text-blue-500 group-hover:text-blue-700">
            {{ $t('View Details') }}
        </div>
    </a>
</template>

<script>
export default {
    props: {
        property_id: {},
        closing_date: {},
        route: {},
    },
}
</script>
